import React, { FC } from 'react';
import styles from './styles.module.css';
import { Asset, BoltIcon } from '@clearcover/atlas';
import { AGENT_REWARDS } from '../../../Shared/constants/rewards';

const BulletPoint: FC<{ size: 'small' | 'large'; text: string }> = ({
  size,
  text,
}) => (
  <div
    className={
      size === 'small'
        ? styles.bulletContainerSmall
        : styles.bulletContainerLarge
    }
  >
    <Asset
      icon={BoltIcon}
      height={size === 'small' ? 16 : 20}
      width={size === 'small' ? 16 : 20}
      description="Reward"
      className={
        size === 'small' ? styles.bulletIconSmall : styles.bulletIconLarge
      }
    />
    <span
      className={
        size === 'small' ? styles.bulletTextSmall : styles.bulletTextLarge
      }
    >
      {text}
    </span>
  </div>
);

export const RewardsBanner = () => {
  return (
    <div className={styles.bannerContainer}>
      <div>
        <BulletPoint
          text="You’re eligible to earn Clearcover Rewards!"
          size="large"
        />
        <span className={styles.sellAPolicyText}>
          Sell a policy that meets our criteria and earn up to $
          {AGENT_REWARDS.value} in points.
        </span>
      </div>
      <div className={styles.smallBulletsContainer}>
        <div className={styles.smallBulletColumn}>
          <BulletPoint text="Multi-driver, multi-vehicle policy" size="small" />
          <BulletPoint text="Good accident history" size="small" />
        </div>
        <div className={styles.smallBulletColumn}>
          <BulletPoint text="Current policy duration 2+ years" size="small" />
          <BulletPoint text="Current BI limit $100K+ per person" size="small" />
        </div>
      </div>
    </div>
  );
};
